export type Language = {
  id: number
  code: string
  nameKey: string
  flag: string
}

export const AVAILABLE_LANGUAGES: Language[] = [
  { id: 1, code: 'fr-FR', nameKey: 'languages.french', flag: '🇫🇷' },
  { id: 2, code: 'en-GB', nameKey: 'languages.english', flag: '🇬🇧' },
  { id: 8, code: 'bg-BG', nameKey: 'languages.bulgarian', flag: '🇧🇬' },
  { id: 11, code: 'hr-HR', nameKey: 'languages.croatian', flag: '🇭🇷' },
  { id: 7, code: 'cs-CZ', nameKey: 'languages.czech', flag: '🇨🇿' },
  { id: 12, code: 'nl-NL', nameKey: 'languages.dutch', flag: '🇳🇱' },
  { id: 13, code: 'et-EE', nameKey: 'languages.estonian', flag: '🇪🇪' },
  { id: 14, code: 'de-DE', nameKey: 'languages.german', flag: '🇩🇪' },
  { id: 15, code: 'el-GR', nameKey: 'languages.greek', flag: '🇬🇷' },
  { id: 16, code: 'hu-HU', nameKey: 'languages.hungarian', flag: '🇭🇺' },
  { id: 17, code: 'it-IT', nameKey: 'languages.italian', flag: '🇮🇹' },
  { id: 19, code: 'lv-LV', nameKey: 'languages.latvian', flag: '🇱🇻' },
  { id: 20, code: 'lt-LT', nameKey: 'languages.lithuanian', flag: '🇱🇹' },
  { id: 21, code: 'pl-PL', nameKey: 'languages.polish', flag: '🇵🇱' },
  { id: 22, code: 'pt-PT', nameKey: 'languages.portuguese', flag: '🇵🇹' },
  { id: 23, code: 'ro-RO', nameKey: 'languages.romanian', flag: '🇷🇴' },
  { id: 25, code: 'sk-SK', nameKey: 'languages.slovakian', flag: '🇸🇰' },
  { id: 26, code: 'sl-SI', nameKey: 'languages.slovenian', flag: '🇸🇮' },
  { id: 27, code: 'es-ES', nameKey: 'languages.spanish', flag: '🇪🇸' },
  { id: 3, code: 'ar', nameKey: 'languages.arabic', flag: '🇸🇦' },
  { id: 4, code: 'ms-MY', nameKey: 'languages.bahasa', flag: '🇲🇾' },
  { id: 5, code: 'kk-KZ', nameKey: 'languages.kazakh', flag: '🇰🇿' },
  { id: 6, code: 'ru-RU', nameKey: 'languages.russian', flag: '🇷🇺' },
  { id: 9, code: 'km-KH', nameKey: 'languages.khmer', flag: '🇰🇭' },
  //{ id: 10, code: 'zh-CN', nameKey: 'languages.chinese', flag: '🇨🇳' },
  { id: 10, code: 'zh-TW', nameKey: 'languages.taiwan', flag: '🇹🇼' },
  { id: 18, code: 'he-IL', nameKey: 'languages.hebrew', flag: '🇮🇱' },
  { id: 24, code: 'sr-SP', nameKey: 'languages.serbian', flag: '🇷🇸' },
  { id: 28, code: 'tr-TR', nameKey: 'languages.turkish', flag: '🇹🇷' },
  { id: 29, code: 'ko-KR', nameKey: 'languages.korean', flag: '🇰🇷' },
  { id: 30, code: 'th-TH', nameKey: 'languages.thai', flag: '🇹🇭' },
]
